<div class="page-wrapper" [ngStyle]="getWrapperDimensions()">
  <div class="page-container"
       [ngStyle]="getDisplayDimensions()"
       [class.landscape]="page.orientation === 'landscape'"
       #pageContainer>

       <ng-container *ngFor="let element of page.elements; let i = index">
          <ng-container [ngSwitch]="element.type">
            <app-report-text
              *ngSwitchCase="'text'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'org-info'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'page-header'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'test-info'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'table-composition'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'traffic-lights'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'raw-test-data'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'lactate-measured'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'lactate-calculated'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-text
              *ngSwitchCase="'training-zones'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-image
              *ngSwitchCase="'image'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-image
              *ngSwitchCase="'org-logo'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
            />

            <app-report-graphic
              *ngSwitchCase="'human-body'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'body-composition'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'metabolic-fingerprint'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'metabolic-capacities-grid'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'metabolic-capacities-single'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'load-charcteristics'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'load-characteristics-single'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'kinetics'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'ppd-cross-validation'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'metabolic-demand'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'lactate-accumulation'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

            <app-report-chart
              *ngSwitchCase="'performance-development'"
              [element]="$any(element)"
              [ngStyle]="getElementStyle(element)"
              [reportConfig]="reportConfig"
              [page]="page"
            />

          </ng-container>
       </ng-container>

  </div>
</div>
